import Automations from '@/features/automations'
import { listAutomationsQuery } from '@/queries/automation.query'
import { AutomationFilters } from '@/types/filters/automation'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/automations/')({
  component: Automations,
  head: () => ({
    meta: [
      {
        title: 'Automações | Wazai',
      },
    ],
  }),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(listAutomationsQuery())
  },
  validateSearch: () => ({}) as AutomationFilters,
})
